import React from "react";
import { CustomCardPayout } from "../../components/customCardPayout/index";
import Spinner from "../../components/presentationals/Spinner";
import Error from "../../components/Error";
import { makeStyles } from "@material-ui/core";
import Alert from "../../components/alert/index";
import { useDispatch, useSelector } from "react-redux";
import { hideAlertPayout } from "../../redux/actions";

const PayoutDashboardView = ({
  dashboardData,
  payoutTiles,
  payoutModules,
  fetchCsv,
  csvLoading,
  timestamp,
  error,
}) => {
  const dispatch = useDispatch();
  const getData = payoutTiles?.filter((row) => row.tileName === "QTY")?.[0];
  const payoutData = payoutTiles?.filter(
    (row) => row.tileName === "PARTNER PAYOUT"
  )?.[0];
  const { showAlert } = useSelector((state) => state.payoutReducer);
  const useStyles = makeStyles((theme) => ({
    container: {
      margin: "10px",
      height: 15,
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      "& > * + *": {
        marginLeft: theme.spacing(2),
      },
    },
  }));
  return (
    <div>
      <h2
        className="pagetitle wow fadeInUp"
        data-wow-delay=".5s"
        data-wow-duration="0.7s"
      >
        {payoutModules?.moduleName}
      </h2>
      {showAlert === "Payout" ? (
        <Alert
          showAlert={showAlert}
          showError={error}
          hideAlert={() => dispatch(hideAlertPayout())}
        />
      ) : null}
      {!dashboardData?.loading ? (
        <div
          className="whitebox wow fadeInUp"
          data-wow-delay=".6s"
          data-wow-duration="0.7s"
          data-cy="payout-section"
        >
          <div className="tabcontbox">
            {dashboardData.data ? (
              <div className="row center">
                {getData?.isTileActive === "Y" ? (
                  <div className="col-md-4">
                    <div className="roundborder actc">
                      <div className="mdnsubtitle">
                        <div className="leftdiv text-payout">Quantity</div>
                        <div
                          style={{
                            float: "right",
                            fontSize: "15px",
                            color: "gray",
                            padding: "3px 0px 0px 18px",
                          }}
                        ></div>
                        {payoutTiles && getData?.isCsvActive === "Y" ? (
                          <>
                            {csvLoading.line ? (
                              <Spinner useStyles={useStyles} />
                            ) : (
                              <span
                                className="downloadarrow"
                                data-cy="csv-download"
                              >
                                <button
                                  type="button"
                                  className="btn btn-link btn-sm m-0 p-0"
                                  onClick={() => {
                                    fetchCsv("line");
                                  }}
                                >
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assets/images/icons/download-arrow.svg"
                                    }
                                    alt="download"
                                  />
                                </button>
                              </span>
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                      <div className="col mt-3 pt-1">
                        <CustomCardPayout
                          value={dashboardData?.data?.qty ?? 0}
                          label={getData.tileName}
                          color="payoutgrad1"
                        />
                      </div>
                      <div
                        className="card-timestamp border-top mt-3"
                        data-cy="timestamp"
                      >
                        <i className="fa fa-history mr-2 mt-2 mb-0"></i>
                        Updated on{" " + timestamp?.item}
                      </div>
                    </div>
                  </div>
                ) : null}
                {payoutData?.isTileActive === "Y" ? (
                  <div className="col-md-4">
                    <div className="roundborder actc">
                      <div className="mdnsubtitle">
                        <div className="leftdiv text-payout">Payout</div>
                        <div
                          style={{
                            float: "right",
                            fontSize: "15px",
                            color: "gray",
                            padding: "3px 0px 0px 18px",
                          }}
                        ></div>
                        {payoutData.isCsvActive === "Y" ? (
                          <>
                            {csvLoading.header ? (
                              <Spinner useStyles={useStyles} />
                            ) : (
                              <span
                                className="downloadarrow"
                                data-cy="csv-download"
                              >
                                <button
                                  type="button"
                                  className="btn btn-link btn-sm m-0 p-0"
                                  onClick={() => {
                                    fetchCsv("header");
                                  }}
                                >
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assets/images/icons/download-arrow.svg"
                                    }
                                    alt="download"
                                  />
                                </button>
                              </span>
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                      <div className="col mt-3 pt-1">
                        <CustomCardPayout
                          value={dashboardData?.data?.payout ?? 0}
                          label={payoutData.tileName}
                          color={`payoutgrad2`}
                        />
                      </div>

                      <div
                        className="card-timestamp border-top mt-2"
                        data-cy="timestamp"
                      >
                        <i className="fa fa-history mr-2 mt-2 mb-0"></i>
                        Updated on{" " + timestamp.header}
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            ) : dashboardData?.error ? (
              <Error error={dashboardData.error} />
            ) : (
              <div
                className="text-center disclaimer "
                data-wow-delay=".6s"
                data-wow-duration="0.7s"
              >
                <ul>
                  <li>{window.CLICK_RUN_1}</li>
                  <li>{window.CLICK_RUN_2}</li>
                </ul>
              </div>
            )}
          </div>
        </div>
      ) : (
        <Spinner />
      )}
    </div>
  );
};

export default PayoutDashboardView;
